import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  authSelector,
  loginUser,
  loginWithEmailPassword,
  validateUserAuth
} from '../../store/slices/auth';
import { clientsSelector, getClients } from '../../store/slices/clients';
import Loading from '../../components/Loading';
import { firebaseAuth } from '../../firebase/firebase';
import './Login.scss';

import { CLIENTS_URL } from '../../utils/constants';

function Login() {
  const dispatch = useDispatch();
  const { isAuthenticated, loading, errorLogin } = useSelector(authSelector);
  const { customerList } = useSelector(clientsSelector);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Determinar si se debe usar email/password login basado en el dominio actual
  const currentOrigin = window.location.origin;
  const useEmailPasswordLogin = currentOrigin === CLIENTS_URL;

  useEffect(() => {
    const unsusbscribe = firebaseAuth.onIdTokenChanged(async (user) => {
      if (user) {
        const idToken = await user.getIdToken(true);
        dispatch(validateUserAuth(user, idToken));
      }

      if (isAuthenticated && customerList.length === 0) {
        dispatch(getClients());
      }
    });

    return () => {
      unsusbscribe();
    };
    // eslint-disable-next-line
  }, [isAuthenticated, customerList.length]);

  const onSubmitGoogle = (event) => {
    event.preventDefault();
    dispatch(loginUser());
    dispatch(getClients());
  };

  const onSubmitEmail = (event) => {
    event.preventDefault();
    if (email && password) {
      dispatch(loginWithEmailPassword(email, password));
      dispatch(getClients());
    }
  };

  const checkAuth = () => {
    if (isAuthenticated && customerList.length === 0) {
      return <Loading message="Getting customers..." />;
    } else if (isAuthenticated) {
      return <Redirect to="/clients" />;
    } else {
      return (
        <div>
          <div className="container-fluid">
            <div className="row justify-content-center min-vh-100">
              <div className="col-12">
                <div className="d-flex flex-column h-100">
                  <div className="row justify-content-center bg-white">
                    <div className="text-white">
                      <div style={{ height: 150 }}>
                        <div
                          style={{
                            height: 150,
                            textAlign: 'center',
                            paddingTop: 20,
                            backgroundColor: 'white'
                          }}>
                          <img
                            src="../assets/img/adler_logo_large.png"
                            className="img-fluid"
                            width="30%"
                            alt="Adler Suite"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center login-wrapper flex-grow-1">
                    <div
                      className="text-white"
                      style={{ paddingTop: 50, textAlign: 'center' }}>
                      {useEmailPasswordLogin ? (
                        <>
                          <p>Login with Email & Password</p>
                          {loading ? (
                            <div className="spinner-grow" role="status" />
                          ) : (
                            <form
                              onSubmit={onSubmitEmail}
                              style={{
                                maxWidth: '300px',
                                margin: '0 auto'
                              }}>
                              <div
                                className="form-group"
                                style={{ marginBottom: '15px' }}>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  required
                                  style={{
                                    padding: '10px',
                                    backgroundColor: 'white',
                                    color: 'black'
                                  }}
                                />
                              </div>
                              <div
                                className="form-group"
                                style={{ marginBottom: '15px' }}>
                                <input
                                  type="password"
                                  className="form-control"
                                  placeholder="Password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                                  style={{
                                    padding: '10px',
                                    backgroundColor: 'white',
                                    color: 'black'
                                  }}
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  width: '100%',
                                  padding: '10px'
                                }}>
                                Login
                              </button>
                            </form>
                          )}
                        </>
                      ) : (
                        <>
                          <p>
                            Please login with your GSuite Account {CLIENTS_URL}{' '}
                            {1 + 1}
                          </p>
                          {loading ? (
                            <div className="spinner-grow" role="status" />
                          ) : (
                            <form onSubmit={onSubmitGoogle}>
                              <button type="submit" className="login-btn">
                                <img
                                  src="./assets/img/google-login/btn_google_signin_dark_normal_web.png"
                                  alt="Google Login"
                                />
                              </button>
                            </form>
                          )}
                        </>
                      )}
                      {errorLogin && (
                        <p className="pt-3">
                          <strong>- {errorLogin} -</strong>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return checkAuth();
}

export default Login;
